<!--组织机构侧边栏-->
<template>
  <div class="organization-box" >

    <div>
      <div class="organization-title" align="center">组织机构</div>
      <div class="organization-list-item" v-for="(item,index) in organizationList" @click="goNext(item.id)">{{item.name}}</div>
    </div>

  </div>
    
</template>

<script>
  export default {
    data() {
      return {
        organizationList:[],


      };
    },

    components: {},

    mounted() {
      this.getOrganizationList();
    },

    methods: {
      goNext(id)
      {
        this.$router.push({path:'/organization',query: {id:id}})
      },

      getOrganizationList() {
        this.instance.get('/api/organization/getlist').then(res => {
          if (res.status == 200) {
            this.organizationList = res.data.organization_list
          }
        })
      },


    },

  }

</script>
<style scoped>
  .organization-box{
    position: relative;
    width: 100%;
    height: 100%;
    background: hsla(0, 0%, 100%, .2);
    border: 0.1vw solid rgb(60, 74, 93, .2);
    box-shadow: 0 0.3vw 0.4vw rgba(0, 0, 0, .12), 0 0 0.6vw rgba(0, 0, 0, .04);
  }

  .organization-title{
    height: 4vw;
    font-size: 1.2vw;
    font-weight: bold;
    color: #3C4A5D;
    /* text-align: center; */
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 0.15vw solid rgba(60,74,93,0.4);
  }
  .organization-list-item{
    height: 4vw;
    width: 100%;
    font-size: 0.9vw;
    font-weight: bold;
    color: #3C4A5D;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    /* border: 1px solid blue; */
  }

  .organization-list-item:hover{

    background-color: rgba(254,232,166,0.4);
  }

</style>



// WEBPACK FOOTER //
// src/components/OrganizationAside.vue